import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getCriterionList(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Criterion/List`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getTopCriterion(supplierId: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Criterion/TopCriterion/${supplierId}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createCriterion(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('Criterion/Create', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateCriterion(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Criterion/UpdateCriterion/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function softDeleteCriterionId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Criterion/SoftDeleteCriterion/${id}`, {}, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function getCategoryList(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Category/List`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}